import { useState, useEffect } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

import Spinner from "../../../components/common/spinner/Spinner";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import Api from "../../components/api/Api";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
// eslint-disable-next-line no-unused-vars
import { ChangePassword } from "./ChangePassword";
import LocationServiceSelector from "../../components/Location/LocationServiceSelector";

const EditPartner = () => {
  const navigate = useNavigate();
  const { partnerId } = useParams();
  // eslint-disable-next-line no-unused-vars
  const { token, userDetails } = useSelector((state) => state.auth.user || {});
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: partnerId,
    first_name: "",
    last_name: "",
    email_address: "",
    mobile_number: "",
    // city_id: "",
    // state_id: "",
    // service_id: "",
  });


  // eslint-disable-next-line no-unused-vars
  const [states, setStates] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [cities, setCities] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [services, setServices] = useState([]);

  const getDetailsApi = Api({ url: `admin/user/id/${partnerId}` });
  const editDetailsApi = Api({ url: `admin/editUser` });

  const headers = { headers: { Authorization: `Bearer ${token}` } };
  const requestBody = { page_number: 1, page_size: 30, order_by: "ASC" };

  useEffect(() => {
    fetchInitialData();
    fetchServices();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      const [userRes, statesRes] = await Promise.all([
        getDetailsApi.fetchData(),
        axios.post(`${baseUrl}/admin/states/1`, requestBody, headers),
      ]);

      const user = userRes.data.user;
      console.log('hi user' ,user)

      setFormData((prev) => ({
        ...prev,
        first_name: user.first_name,
        last_name: user.last_name,
        email_address: user.email_address,
        mobile_number: user.mobile_number,
        
      }));
      console.log("form Data:", formData);

      setStates(statesRes.data.states || []);

      if (user.states?.[0]?.id) {
        fetchCities(user.states[0].id);
      }
    } catch (error) {
      showToast("Error fetching data", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const res = await axios.post(`${baseUrl}/admin/cities/${stateId}`, requestBody, headers);
      setCities(res.data.cities || []);
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };

  const fetchServices = async () => {
    try {
      const res = await axios.post(`${baseUrl}/admin/services`, requestBody, headers);
      setServices(res.data.services || []);
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // eslint-disable-next-line no-unused-vars
  const handleStateChange = (e) => {
    const selectedStateId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      state_name: selectedStateId,
      city_name: "",
    })); 
    fetchCities(selectedStateId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await editDetailsApi.editData(formData);
      console.log("Edit response:", res);
      if (res.data.statusType === "SUCCESS") {
        showToast("Partner Edited Successfully", { type: "success" });
        setTimeout(() => navigate("/partners"), 2000);
      }
    } catch {
      showToast("Update failed", { type: "error" });
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Team Management", link: "/user" },
    { label: "Edit User Details", active: true },
  ];

  return (
    <>
      <Notification />
      <Container fluid className="mt-4 px-5">
        <Row>
          <BreadCrumb items={breadcrumbItems} />
          <Col lg={3}></Col>

          <Col lg={8}>
            <SingleDetailHeader
              header="Edit User Details"
              description="Edit User details section"
            />

            {isLoading ? ( 
              <Spinner />
            ) : (
              <Form onSubmit={handleSubmit} className="p-4 ">

                {/* Section: User Info */}
                <h5 className="mb-4 fw-semibold text-primary">User Information</h5>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group controlId="userId">
                      <Form.Label className="fw-medium">User ID</Form.Label>
                      <Form.Control type="text" name="id" value={formData.id} disabled readOnly className="bg-light" />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="first_name">
                      <Form.Label className="fw-medium">First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        placeholder="Enter first name"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="last_name">
                      <Form.Label className="fw-medium">Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        placeholder="Enter last name"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Section: Contact Info */}
                <h5 className="mb-4 mt-5 fw-semibold text-primary">Contact Details</h5>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="email_address">
                      <Form.Label className="fw-medium">Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email_address"
                        value={formData.email_address}
                        onChange={handleInputChange}
                        placeholder="example@email.com"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="mobile_number">
                      <Form.Label className="fw-medium">Mobile Number</Form.Label>
                      <Form.Control
                        type="tel"
                        name="mobile_number"
                        value={formData.mobile_number}
                        onChange={handleInputChange}
                        placeholder="+91 XXXXXXXXXX"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Section: Location & Service */}
                <h5 className="mb-4 mt-5 fw-semibold text-primary">Location & Service</h5>
                <Row className="mb-3">
                  <LocationServiceSelector userId={partnerId} />
                  {/* <Col md={4}>
                    <Form.Group controlId="state_name">
                      <Form.Label className="fw-medium">State</Form.Label>
                      <Form.Select
                        name="state_name"
                        value={formData.state_name}
                        onChange={handleStateChange}
                        className="shadow-sm"
                      >
                        <option value="">Select State</option>
                        {states.map(state => (
                          <option key={state.id} value={state.id}>{state.name}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="city_name">
                      <Form.Label className="fw-medium">City</Form.Label>
                      <Form.Select
                        name="city_name"
                        value={formData.city_name}
                        onChange={handleInputChange}
                        className="shadow-sm"
                      >
                        <option value="">Select City</option>
                        {cities.map(city => (
                          <option key={city.id} value={city.id}>{city.name}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="service_id">
                      <Form.Label className="fw-medium">Service</Form.Label>
                      <Form.Select
                        name="service_id"
                        value={formData.service_id}
                        onChange={handleInputChange}
                        className="shadow-sm"
                      >
                        <option value="">Select Service</option>
                        {services.map(service => (
                          <option key={service.id} value={service.id}>{service.name}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col> */}
                </Row>

                {/* Buttons */}
                <div className="d-flex justify-content-start mt-4">
                  <Button type="submit" variant="primary" className="px-4 me-3">Update</Button>
                  <Link to="/partners" className="btn btn-outline-secondary px-4">Back</Link>
                </div>
              </Form>
            )}

            {/* {userDetails?.id !== +formData.id && (
              <Row className="p-4 ">
                <SingleDetailHeader header="Change Password" />
                <ChangePassword />
              </Row>
            )} */}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditPartner;